import {
  SearchNameType,
  SearchActionType,
  SearchTypeTypes,
} from '../../../types/tracking-search'

export type SearchEvent = {
  GA3: {
    event: 'search'
    label: string
    searchTermCompleted: string
    action: SearchNameType
    searchDestination: string
  }
  GA4: {
    event: 'search'
    label: string
    name: SearchNameType
    action: SearchActionType
    search_term_completed: string
    search_destination: string
    search_type: SearchTypeTypes
  }
}

export type trackSearchParams = {
  label: string
  name: SearchNameType
  searchTermCompleted: string
  action: SearchActionType
  searchDestination: string
  searchType: SearchTypeTypes
}

export const trackSearch = ({
  label,
  name,
  searchTermCompleted,
  action,
  searchDestination,
  searchType,
}: trackSearchParams): SearchEvent => {
  const eventGA3: SearchEvent['GA3'] = {
    event: 'search',
    label,
    action: name,
    searchTermCompleted,
    searchDestination,
  }

  const eventGA4: SearchEvent['GA4'] = {
    event: 'search',
    label,
    action,
    name,
    search_term_completed: searchTermCompleted,
    search_destination: searchDestination,
    search_type: searchType,
  }

  return {
    GA3: eventGA3,
    GA4: eventGA4,
  }
}
